<template>
  <v-app>
    <v-main>
      <MainLayout />
    </v-main>
  </v-app>
</template>

<script>

import MainLayout from '@/layouts/MainLayout';
import { $host } from '@/services';

export default {
  name: 'App',
  components: { MainLayout },
  beforeCreate() {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      $host.defaults.headers['Authorization'] = `Bearer ${accessToken}`;
      this.$store.commit('setStatusAuth', true);

      const isViewAdminPanel = localStorage.getItem('isViewAdminPanel') === 'true';
      this.$store.commit('setStatusViewAdminPanel', isViewAdminPanel);
    }
  },
};
</script>

<style lang='scss'>
@import './assets/styles/theme';
@import './assets/styles/mixins';
@import './assets/styles/main';
@import './assets/styles/reset';

#app {
  width: 100%;
  height: 100vh;
}

:root {
  --color-black: $color-black;
  --color-gray: $color-gray;
  --color-gray-dark: $color-gray-dark;
  --color-blue: $color-blue;
  --color-blue-500: $color-blue-500;
  --color-blue-900: $color-blue-900;
  --color-orange: $color-orange;
  --color-orange-500: $color-orange;
  --color-green: $color-green;
  --color-red: $color-red;
  --color-white: $color-white;
  --color-primary: $color-primary;
  --color-secondary: $color-secondary;
  --color-success: $color-success;
  --color-warning: $color-warning;
  --color-error: $color-error;
}
</style>